/**
 * A Regex that recognizes regular participles. NOTE: this often coincides with simple past forms.
 * @type {RegExp}
 */
export const regularParticiplesRegex = /\w+ed($|[ \n\r\t.,'()"+\-;!?:/»«‹›<>])/ig;
